import { User } from './user'

export class SalesmanSearch {
	salesmen: [User]
	searchString: string
}